module.exports = __webpack_public_path__ + "static/img/bg.00c27c0d.png";